import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css'],
})
export class PricingComponent {
  departments: any[] = [];
  language!:string;
  routeSub!: Subscription; 

  constructor(private route: ActivatedRoute,
    private metaTagService:MetaTagService) {}

  ngOnInit(): void {
      this.language = this.route.snapshot.url[0].path    
      
      this.routeSub = this.route.params.subscribe(params => {
        if (params['lang']) {
          this.language = params['lang'];
          this.getResolverData(); 
        }
      });       
      this.getResolverData();     
  }

  getResolverData(){
    const resolverData = this.route.snapshot.data['pricingData'];
    if (resolverData) {
      this.departments = resolverData.data.departments;
      this.metaTagService.updateMetaTags(resolverData.meta.meta);
    } else {
      console.error("Resolver data is undefined");
    }        
  }
}
